<template>
  <section class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
    <div class="lg:col-span-2">
      <ol class="order-items-checkout">
        <li class="order-items-checkout__column-headers grid grid-cols-12 gap-4">
          <div class="order-items-checkout__column-header text col-span-12 lg:col-span-6 invisible">
            {{ $t('basket.page.item') }}
          </div>
          <div class="order-items-checkout__column-header text col-span-12 lg:col-span-2">
            {{ $t('order.price') }}
          </div>
          <div class="order-items-checkout__column-header text col-span-12 lg:col-span-2">
            {{ $t('text.quantity') }}
          </div>
          <div class="order-items-checkout__column-header text col-span-12 lg:col-span-2">
            {{ $t('text.total') }}
          </div>
        </li>
        <order-items-table-entry
          v-for="entry in orderGroup.entries"
          :key="entry.product.code"
          :entry="entry"
          :applied-order-promotions="order.appliedOrderPromotions"
        />
      </ol>
    </div>
    <order-items-table-totals :order="order" />
  </section>
</template>

<script>
import OrderItemsTableEntry from '@/components/order-items-table/OrderItemsTableEntry.vue';
import OrderItemsTableTotals from '@/components/order-items-table/OrderItemsTableTotals.vue';

export default {
  name: 'OrderItemsTable',
  components: {OrderItemsTableEntry, OrderItemsTableTotals},
  props: {
    order: {
      type: Object,
      default: () => ({}),
    },
    orderGroup: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
